import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=4c0ec8a6&"
import script from "./SuppliersTable.vue?vue&type=script&lang=js&"
export * from "./SuppliersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports